import { VideoSource } from "@/constants/media";
import type { Noop } from "@/types";
import CoreVideo, { type CoreVideoProps } from "./services/CoreVideo";
import VimeoVideo, { type VimeoOptions } from "./services/VimeoVideo";
import WistiaVideo, { type WistiaOptions } from "./services/WistiaVideo";
import YouTubeVideo, { type YouTubeOptions } from "./services/YouTubeVideo";

export interface VideoServiceProps extends CoreVideoProps {
  source: VideoSource;
  vimeoOptions?: VimeoOptions;
  wistiaOptions?: WistiaOptions;
  youtubeOptions?: YouTubeOptions;
}

export default function VideoService(props: VideoServiceProps) {
  const {
    ref,
    source,
    videoId,
    vimeoOptions,
    wistiaOptions,
    youtubeOptions,
    ...videoProps
  } = props;

  switch (source) {
    // Also used as a background video
    case VideoSource.Core:
      return <CoreVideo ref={ref} videoId={videoId} {...videoProps} />;

    case VideoSource.Vimeo:
      return <VimeoVideo videoId={videoId} options={vimeoOptions} />;

    // Also used as a background video
    case VideoSource.Wistia:
      return (
        <WistiaVideo
          ref={ref}
          videoId={videoId}
          options={wistiaOptions}
          onPlay={props.onPlay as Noop}
        />
      );

    case VideoSource.YouTube:
      return <YouTubeVideo videoId={videoId} options={youtubeOptions} />;

    default:
      return null;
  }
}
